module.exports = __webpack_public_path__ + "b9d6b6d2fd05f22bd7faf4291060228a.svg";